<template>
  <v-dialog v-model="localValue" width="300" persistent>
    <v-card class="mx-auto">
      <v-card-text class="text-center pa-5">
        <v-progress-circular class="mr-4" indeterminate></v-progress-circular>
        <span>Loading {{ text }}...</span>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    text: {
      type: String,
      default: () => "",
    },
  },
  computed: {
    localValue: {
      get() {
        return this.show;
      },
    },
  },
};
</script>

<style>
/* Add some styles if needed */
</style>
